<template>
    <kt-button class="ml-2" @click="goBack()" variant="twitter">{{ $t('label.back') }}<i class="pl-2 fa fa-arrow-left"></i></kt-button>
</template>

<script>
export default {
    
}
</script>